import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type { CrmPageQuery, CrmPageResult } from './types/crm';

const request = createAppRequest();

export async function queryCrmResource<T = Record<string, unknown>>(
  resourcePath: string,
  params: CrmPageQuery,
  options?: ApiRequestOptions,
) {
  return request<CrmPageResult<T>>(`/bff/zy-crm/${resourcePath}`, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
